import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { DescriptionDto } from '@/api';
import highlight from '@/utils/filters/highlight';
import { getProviderIconSrc } from '@/utils/provider-icons';
import i18n from '@/i18n';
import { onMounted } from 'vue';
import SRichTextViewer from '@/components/SRichTextViewer.vue';
import SHtmlView from '@/components/SHtmlView/SHtmlView.vue';

interface ExternalDescriptionProps {
  description: DescriptionDto;
  search?: string;
  shouldShowRichtext?: boolean;
  hideIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'External-Description',
  props: {
  description: null,
  search: { default: '' },
  shouldShowRichtext: { type: Boolean, default: false },
  hideIcon: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const descriptionRef = _ref<InstanceType<typeof SHtmlView>>();

let isOpen = _ref(false);
let canFold = _ref(false);

const alt = _computed(() => props.description?.sourceType);
const matchedDescription = _computed(() => highlight(props.description.description || '', props.search || ''));
const text = _computed(() => (isOpen.value ? i18n.t('common.words.show_less') : i18n.t('common.words.show_more')));
const classes = _computed(() => (isOpen.value ? 'limit-line limit-line--no-limit' : 'limit-line limit-line-2'));

const setCanFold = () => {
  if (!props.shouldShowRichtext) {
    const el = descriptionRef.value?.$el;
    canFold.value = el?.scrollHeight && el?.clientHeight ? el?.scrollHeight > el?.clientHeight : false;
  }
};

const toggleOpenState = () => {
  isOpen.value = !isOpen.value;
};

onMounted(() => setCanFold());

return { __sfc: true,props, descriptionRef, isOpen, canFold, alt, matchedDescription, text, classes, setCanFold, toggleOpenState, _ref, _computed, DescriptionDto, highlight, getProviderIconSrc, i18n, onMounted, SRichTextViewer, SHtmlView }
}

})